import { useEffect } from 'react';
import { LifeBuoy } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useMe } from '@/lib/auth';
import { bfocusInit, bfocusOpenWhenReady, bfocusDestroy, bfocusEnabled } from '@/lib/bfocus';

// Suporte no mobile: o bFocus não tem modo inline, então aqui carregamos o widget
// sob demanda e ABRIMOS o painel (tela cheia no celular). Ao sair, descarregamos
// para liberar a tela — o launcher flutuante não fica.
export function Support() {
  const { data: me } = useMe(true);

  useEffect(() => {
    if (!bfocusEnabled() || !me) return;
    bfocusInit(me);
    const stop = bfocusOpenWhenReady();
    return () => { stop(); bfocusDestroy(); };
  }, [me]);

  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 py-16 text-center">
        <LifeBuoy className="size-8 text-primary" />
        {bfocusEnabled() ? (
          <>
            <p className="text-sm text-muted-foreground">Abrindo o suporte…</p>
            <Button variant="outline" size="sm" onClick={() => window.bFocus?.open?.()}>Reabrir suporte</Button>
          </>
        ) : (
          <p className="text-sm text-muted-foreground">Suporte não configurado.</p>
        )}
      </CardContent>
    </Card>
  );
}
